module.exports = __webpack_public_path__ + "img/approve.05d5388a.svg";